/**
 * @fileOverview Loads city data and passes it to child component.
 * Loads the following info and passes down as props
 * - clients
 * - campaigns
 * - locations
 */

import React, { useState, useEffect } from 'react'
import { getCountries } from './../../../Module/graphQL'
import { authorization } from 'Module/Auth/Auth'

const CountriesData = props => {
  const { children, ...otherProps } = props

  const [countries, setCountries] = useState([])

  // Will be set to true once the filter info has been requested
  const [requested, setRequested] = useState(false)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (requested) return
    setRequested(true)
    ;(async () => {
      const authToken = await authorization.getAPIKey()
      // Include hidden countries (like Israel for Promofy)
      var response = await getCountries(authToken, true)
      var result = await response.json()
      if (result['errorMessage']) throw new Error(result['errorMessage'])
      if (result.errors && result.errors[0])
        throw new Error(result.errors[0].message)

      setCountries(result.data.countries.nodes)
      setLoaded(true)
    })()
  })

  return React.cloneElement(children, {
    ...otherProps,
    countries,
    countriesLoaded: loaded,
  })
}

export default CountriesData
